module.exports = __webpack_public_path__ + "img/home_img_earth_left.f1b4a1e5.png";